import { render, staticRenderFns } from "./CustomCheckBox.vue?vue&type=template&id=36f6344a"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckBox.vue?vue&type=style&index=0&id=36f6344a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports